import { forwardRef, type ComponentType } from 'react'
import { CircularProgress, type ButtonBaseTypeMap, type ExtendButtonBase } from '@mui/material'
import * as $ from './Fab.styled'

export interface FabProps extends Omit<$.RootProps, 'labelOn'> {
  /**
   * Element placed before the children.
   */
  icon: React.ReactNode
  loading?: boolean
}

export const Fab = forwardRef<HTMLButtonElement, FabProps>(
  ({ icon, kind = 'neutral', size = 'small', variant = 'primary', children, loading, disabled, ...props }, ref) => (
    <$.Root
      ref={ref}
      kind={kind}
      size={size}
      variant={variant}
      labelOn={Boolean(children)}
      disabled={loading || disabled}
      {...props}
    >
      <$.IconBox size={size} labelOn={Boolean(children)}>
        {loading ? <CircularProgress size="inherit" color="inherit" /> : icon}
      </$.IconBox>
      {children}
    </$.Root>
  ),
) as ExtendButtonBase<ButtonBaseTypeMap<FabProps>> & Pick<ComponentType, 'displayName'>

Fab.displayName = 'Fab'
